var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import { TonicEphemeralIcon, TonicIcon, TonicTextualIcon, TonicValidateIcon } from "../_logos/index.js";
export function QuiNav(_a) {
    var { variant, fluid, clamp, padding, logo, className, children } = _a, otherProps = __rest(_a, ["variant", "fluid", "clamp", "padding", "logo", "className", "children"]);
    const cn = classNames(className, "qui-nav", `qui-nav-${variant !== null && variant !== void 0 ? variant : "purple"}`);
    const maybeFluid = fluid ? "-fluid" : "";
    const contentSizingClassName = classNames(`qui-padding-none-${padding !== null && padding !== void 0 ? padding : "lg"}`, {
        [`qui-container`]: !clamp && !fluid,
        [`qui-container${maybeFluid}-${clamp}`]: !!clamp,
        [`qui-container-max-wide`]: fluid && !clamp,
    });
    return (React.createElement("nav", Object.assign({ className: cn }, otherProps),
        React.createElement("div", { className: contentSizingClassName },
            React.createElement("div", { className: "qui-nav-content" },
                logo === "tonic" && (React.createElement("span", { className: "qui-nav-logo-wrapper qui-nav-logo-wrapper-tonic" },
                    React.createElement(TonicIcon, null))),
                logo === "textual" && (React.createElement("span", { className: "qui-nav-logo-wrapper qui-nav-logo-wrapper-textual" },
                    React.createElement(TonicTextualIcon, null))),
                logo === "validate" && (React.createElement("span", { className: "qui-nav-logo-wrapper qui-nav-logo-wrapper-validate" },
                    React.createElement(TonicValidateIcon, null))),
                logo === "ephemeral" && (React.createElement("span", { className: "qui-nav-logo-wrapper qui-nav-logo-wrapper-ephemeral" },
                    React.createElement(TonicEphemeralIcon, null))),
                children))));
}
